import React from 'react';
import classNames from 'classnames';
import { FieldRenderProps } from 'react-final-form';
import RadioSlider, {
  RadioSliderProps,
} from 'components/RadioSlider/RadioSlider.component';
import FieldWrapper from 'components/FieldWrapper';
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper.component';

import './RadioSliderField.styles.scss';

type RadioSliderFieldProps<T extends string> = FieldRenderProps<
  T,
  HTMLElement
> &
  RadioSliderProps<T> &
  FieldWrapperProps;

function RadioSliderField<T extends string>(props: RadioSliderFieldProps<T>) {
  const { className, label, input, ...rest } = props;

  const classes = classNames('radio-slider-field', className);

  return (
    <FieldWrapper className={classes} label={label} {...rest}>
      <RadioSlider {...rest} {...input} />
    </FieldWrapper>
  );
}

export default RadioSliderField;
